import { useTranslation } from 'react-i18next'

const PoliticianEnd = (props) => {
  const { t } = useTranslation()
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="politician-end-title"
      {...props}
    >
      <title id="politician-end-title">{t('antagonists:politician:components:end')}</title>
      <path
        d="m1767.36 806.96-296.71-45.64s-11.39 86.78-25.61 184.97c-14.22 98.17 17.34 273.05 11.16 374.83-5.26 86.57-15.43 295.33-15.43 295.33s15.64 15.66 42.73 13.56c21.26-1.65 66.07-9.76 66.07-9.76s40.78-265.45 40.78-299.83c0-34.39 4.5-254.17 15.38-254.44 4.26-.09 38 199.76 41.03 245.61 3.01 45.85 71.91 323.61 71.91 323.61s8.76 1.06 44.96 3.92 52.72-24.57 52.72-24.57-3.86-98.32-11.42-163.86c-10.27-88.97-8.93-119.96-11.95-188.73-3.03-68.77 3.4-172.35-7.38-298.11-9.99-116.61-18.18-156.88-18.18-156.88h-.04Z"
        style={{
          fill: '#5b3346',
        }}
      />
      <path
        d="M1651.71 367.78c-3.27-3.27-83.43 13.28-96.52 19.18-3.9 1.74-16.21 17.42-25.53 21.88-21.96 10.52-58.71 28.81-72.03 37.53-18.97 12.43 4.9 28.11-5.58 85.72-10.48 57.6-27.88 156.35-26.58 216.57 1.31 60.24-17.69 216.55-17.69 216.55s106.66 30.96 176.7 38.81c70.06 7.85 218.82-36.6 218.82-36.6s-3.03-39.7-4.33-65.88c-1.31-26.18-22.68-101.89-17.78-160.07.79-9.38 25.74-8.11 26.4-18.06 3.03-45.89-1.59-166.39-6-215.38-3.97-44.01-80.54-86.55-104.11-99-23.57-12.45-36.28-31.7-45.83-41.25h.04Z"
        style={{
          fill: '#2e425b',
        }}
      />
      <path
        d="M1585.04 572.41c4.88-10.4 75.05-190.11 76.07-203.2 1.04-13.09-17.7-15.15-19.77-15.15s-87.61 11.52-89.31 22.98c-1.68 11.39 1.82 52.53 9.04 86 6.22 28.88 5.75 105.52 5.75 105.52l9.33 139.91 7.96 1.68s.45-136.71.95-137.76h-.02Z"
        style={{
          fill: '#e6f1e2',
        }}
      />
      <path
        d="M1504.73 472.62 1478.36 724l-91.11-24.34s-30.98-2.23-20.43-28.6 50.65-184.89 83.55-215.68l54.36 17.25Z"
        style={{
          fill: '#2e425b',
        }}
      />
      <path
        d="m1651.73 321.44-106.85 4.24s9.57 26.88 11.5 43.09c1.91 16.21 1.57 18.56 1.57 18.56l22.75 41.86s72.35-56.1 70.38-55.68c0 0 4.86-5.01 1.38-15.81-3.48-10.8-.78-36.26-.78-36.26l.04.02Z"
        style={{
          fill: '#e2a972',
        }}
      />
      <path
        d="M1584.57 167.57c-45.68 4.01-59.71 40.36-61.72 76.38-2 36.01 5.54 51.77 5.54 51.77l138.06-6.68s.81-31.59-3.2-63.61c-3.99-32-20.3-34.29-33.27-42.14-12.98-7.85-21.35-17.82-45.41-15.72Z"
        style={{
          fill: '#c4c7c9',
        }}
      />
      <path
        d="M1584.96 176.44c-16.34 1.34-50.26 28.62-55.93 42.96-5.67 14.34 1.99 56.03 1.99 56.03s-8.3-6.37-12.64-2.04-.85 34.42 4.48 44.77c5.33 10.35 14.3 8.11 14.3 8.11s.81 22.41 5.81 32.42c5.01 10.01 36.45 26.4 49.12 27.75 12.67 1.32 43.3-13.07 54.63-27.07 11.33-14.02 12.28-39.59 12.28-39.59s-.55-.38 8.45-3.05c9.02-2.67 17.34-50.03 7.68-56.03-9.68-6-21.01 15.68-21.01 15.68s-8.32-18.35-8.66-28.35c-.34-10.01 6.66-40.57-4.54-51.01-14.47-13.51-36.01-22.21-55.95-20.58Z"
        style={{
          fill: '#e2a972',
        }}
      />
      <path
        d="M1611.22 275.17c-3.42-1.19-6.51.7-7.17 3.14-.95 3.46.34 6.28 3.95 7.28 3.05.83 5.62.25 6.88-2.99s-.32-6.28-3.65-7.43h-.02ZM1622.89 267.59l-18.44-.72-.99 4.99 18.48 4.45.95-8.72zM1553.77 276.55c3.42-1.19 6.51.7 7.17 3.14.95 3.46-.34 6.28-3.95 7.28-3.05.83-5.64.23-6.88-2.99-1.27-3.23.32-6.28 3.65-7.43h.02ZM1542.25 270.35l17.07-1.88.41 5.21-15.81 3.99-1.67-7.32z"
        style={{
          fill: '#272a3e',
        }}
      />
      <path
        d="M1592.95 255.76s11.86-2.97 20.54-1.23c10.59 2.12 16.78 3.84 16.78 3.84l2.8-2.59s-8.17-11.84-19.27-13.69-22.64 4.1-22.64 4.1l1.8 9.57ZM1564.52 246.78s-4.56-.96-15.98 2.04c-11.42 3.01-17.63 12.63-17.63 12.63l4.26 3.63s5.03-.34 11.99-4.92c6.98-4.6 17.16-2.12 17.16-2.12l.23-11.29-.02.02Z"
        style={{
          fill: '#c4c7c9',
        }}
      />
      <path
        style={{
          fill: '#d88b46',
        }}
        d="m1598.09 295.26 18.05 16.55 6.37-2.27-16.85-21-7.57 6.72zM1559.07 290.77l-13.28 19.92 6.98 3.65 14.94-18.25-8.64-5.32zM1621.58 338.38l1.65 21.06-6.47.85-2.29-19.39 7.11-2.52zM1555.59 355.05l4.96.43 3.1-18.74-6.96-.04-1.1 18.35z"
      />
      <path
        d="M1522.53 272.98v5.64s3.97.91 6.22 4.92c2.35 4.16 7.49 20.05 26.01 18.42 13.64-1.19 18.65-7.23 21.87-15.3 2.57-6.49.36-12.79 1.36-14.36.79-1.25 6.47-1.38 7.38-.55 1.4 1.32 1.1 8.23 4.92 13.68 5.47 7.77 12.45 12.16 25.55 10.63 20.22-2.35 21.62-21.05 21.62-25.82s14.83-10.35 14.83-10.35l-1.89-4.75s-9.85 4.1-13.77 3.65c-6.49-.76-9.84-4.39-25.33-4.54-12.9-.13-18.44 6.92-21.77 9.34-3.4 2.48-14.68 2.36-16.72 1.34-3.42-1.72-13.49-6.45-25.01-3.86-11.5 2.59-12.81 7.98-16.02 9.65-4.1 2.12-9.21 2.25-9.21 2.25h-.04Zm78.36 16c-7.66-4.48-9.67-10.89-8.74-16.42.93-5.5 6.6-11.88 16.55-12.9 8.49-.87 16.97.45 21.37 6.66 3.76 5.32 1.87 12.96-3.27 19.22-5.14 6.26-18.27 7.94-25.93 3.46l.02-.02Zm-59.64 5.01c-5.81-5.09-8.23-12.48-5.88-18.44 2.74-6.96 10.74-10.52 19.6-10.63 9.12-.11 15.36 4.1 17.25 9.32 1.89 5.22 1.34 11.9-4.63 17.84-5.98 5.94-20.54 7.04-26.33 1.93v-.02Z"
        style={{
          fill: '#1c3628',
        }}
      />
      <path
        d="M1568.49 337.99c-3.1 4.39 4.96 11.48 16.1 13.96s22.55-1.12 23.61-5.26c1.87-7.36-5.88-9.91-11.56-10.42-5.33-.49-10.35.96-16.61.34-6.87-.66-9.02-2.21-11.56 1.4l.02-.02Z"
        style={{
          fill: '#ef8227',
        }}
      />
      <path
        d="M1442.71 636.67c-2.7 10.02 4.5 20.18 5.35 24.93.85 4.75-4.96 12.65-3.03 18.16 1.93 5.5 9.29 16.19 9.29 16.19s5.96 3.01 12.31 5.83c6.37 2.84 11.39 6.49 11.39 6.49s2.21-2.19 3.82-6.32-2.1-8.34-2.1-8.34 25.1 18.21 35.79 21.92c10.69 3.71 14.07 2.23 20.6 1.04 6.53-1.17 26.22 6.98 26.22 6.98l6.88-48.67s-24.66-4.96-31.4-8.06c-6.73-3.1-29.98-33.2-38.02-37.73-8.02-4.52-43.84-2.65-43.84-2.65l-13.28 10.23h.02Z"
        style={{
          fill: '#e2a972',
        }}
      />
      <path
        d="M1558.26 700.03c-8.36 21.39-1.66 46.3-1.66 46.3s9.87 3.61 42.2 8.02c32.33 4.41 72.63 26.23 136.51 15.96 63.87-10.25 77.25-29.26 71.71-63.12-5.56-33.86-73.33-45.7-93.21-42.9-19.88 2.8-147.87 7.06-147.87 7.06s-2.29 14.85-7.7 28.69l.04-.02Z"
        style={{
          fill: '#2e425b',
        }}
      />
      <path
        style={{
          fill: '#5b3346',
        }}
        d="m1548.91 1027.41 24.82-133.79 4.33-.96 18.44 134.56-47.59.19z"
      />
      <path
        d="M1644.47 634.23c-10.06-3.29-26.92-8.3-39.72-1.27-12.81 7.02-31.02 25.72-40.99 37.15-9.97 11.42-43.03 10.14-43.03 10.14v44.68s49.99-8.04 63.46-15.74c13.47-7.7 30.32-34.41 33.1-38.04 2.8-3.61 28.94 6.26 37.24 8.36 8.3 2.08 11.08-4.22 11.08-4.22l-10.48-8.51s5.9 1.57 12.2 3.01c6.3 1.42 12.28-7.3 12.28-7.3l-10.21-7.7s10.71 1.27 15.11-.23c4.41-1.51 3.42-8.32 3.42-8.32s-34.24-9.04-43.43-12.05l-.04.04Z"
        style={{
          fill: '#e2a972',
        }}
      />
      <path
        d="M1567.26 661.39s-22.51-3.1-44.11-2.48c-21.62.62-43.9-17.91-97.54-8.23-53.62 9.68-63.53 19.27-61.53 40.87 3.46 37.26 29.15 44.18 56.27 50.14 27.12 5.96 152.28-18.8 152.28-18.8s-3.52-22.04-5.26-35.65c-1.74-13.6-.11-25.86-.11-25.86Z"
        style={{
          fill: '#2e425b',
        }}
      />
    </svg>
  )
}

export default PoliticianEnd
